import type { Post } from '$lib/content';
import { absoluteUrl, site } from '$lib/site';

type PageSeoInput = {
	title: string;
	description: string;
	path: string;
	type?: 'website' | 'article';
	image?: string;
	keywords?: string[];
	publishedTime?: string;
};

export function buildPageSeo({
	title,
	description,
	path,
	type = 'website',
	image = site.socialImage,
	keywords = [],
	publishedTime
}: PageSeoInput) {
	return {
		title: `${title} | ${site.name}`,
		description,
		canonical: absoluteUrl(path),
		image: absoluteUrl(image),
		type,
		keywords: keywords.join(', '),
		publishedTime
	};
}

export function renderJsonLd(schema: object) {
	return `<script type="application/ld+json">${JSON.stringify(schema).replaceAll('<', '\\u003c')}</script>`;
}

export function buildPersonSchema(path: string, description: string) {
	return {
		'@context': 'https://schema.org',
		'@type': 'Person',
		name: site.name,
		url: absoluteUrl(path),
		image: absoluteUrl(site.portraitImage),
		jobTitle: 'Software Engineer',
		description
	};
}

export function buildBlogPostingSchema(post: Post & { slug: string }) {
	return {
		'@context': 'https://schema.org',
		'@type': 'BlogPosting',
		headline: post.title,
		description: post.description,
		datePublished: post.date,
		author: {
			'@type': 'Person',
			name: site.name,
			url: site.url
		},
		publisher: {
			'@type': 'Person',
			name: site.name,
			url: site.url
		},
		mainEntityOfPage: absoluteUrl(`/writing/${post.slug}`),
		url: absoluteUrl(`/writing/${post.slug}`),
		image: absoluteUrl(site.socialImage),
		keywords: post.tags
	};
}
